// extracted by mini-css-extract-plugin
export default {"input":"input_input__PxG4-","error-input":"input_error-input__585j7"};